import React from 'react';
import DiagnosticsSectionHeader from './components/DiagnosticsSectionHeader';
import DiagnosticsDynamicTablePanel from './components/DiagnosticsDynamicTablePanel';
import ShowMetadata from './ShowMetadata';
import {
  buildBatteryFirstHeaders,
  buildEventSummaryHeaders,
  resolveBatteryStickyKey,
} from './utils/diagnosticsDynamicTableColumns';

const stickyTableProps = {
  resolveHeaders: buildBatteryFirstHeaders,
  resolveStickyColumnKey: resolveBatteryStickyKey,
};

const ShowSummaryData = (props) => {
  const {
    csDiagnostics,
    setIsLoading,
    metadataRows,
    metadataColumns,
    metadataPanelVisible,
    onLoadMetadata,
    onStartMetadata,
    onStopMetadata,
  } = props;

  return (
    <div className="row g-3 mb-4">
      <div className="col-12 text-center">
        <DiagnosticsSectionHeader>DETAILED SUMMARY</DiagnosticsSectionHeader>
      </div>
      <div className="col-md-6">
        <DiagnosticsDynamicTablePanel
          title="CHARGING STATION DATA"
          endpoint="cs_data"
          sectionId="cs-data"
          exportTableKey="charging-station-data"
          csDiagnosticsParams={csDiagnostics}
          setIsLoading={setIsLoading}
          fixedHeight={420}
          {...stickyTableProps}
        />
      </div>
      <div className="col-md-6">
        <DiagnosticsDynamicTablePanel
          title="BATTERY CHARGING SUMMARY"
          endpoint="battery_charging_summary"
          sectionId="battery-summary"
          exportTableKey="battery-charging-summary"
          csDiagnosticsParams={csDiagnostics}
          setIsLoading={setIsLoading}
          fixedHeight={420}
          {...stickyTableProps}
        />
      </div>
      <div className="col-md-6">
        <DiagnosticsDynamicTablePanel
          title="EVENT DETAILS"
          endpoint="event"
          sectionId="event-data"
          exportTableKey="event-details"
          csDiagnosticsParams={csDiagnostics}
          setIsLoading={setIsLoading}
          fixedHeight={420}
          {...stickyTableProps}
        />
      </div>
      <div className="col-md-6">
        <DiagnosticsDynamicTablePanel
          title="EVENT SUMMARY"
          endpoint="event_summary"
          sectionId="event-summary"
          exportTableKey="event-summary"
          csDiagnosticsParams={csDiagnostics}
          setIsLoading={setIsLoading}
          fixedHeight={420}
          resolveHeaders={buildEventSummaryHeaders}
          resolveStickyColumnKey={resolveBatteryStickyKey}
        />
      </div>
      {metadataPanelVisible && (
        <div className="col-12">
          <ShowMetadata
            rows={metadataRows}
            columns={metadataColumns}
            csDiagnostics={csDiagnostics}
            onLoadMetadata={onLoadMetadata}
            onStartMetadata={onStartMetadata}
            onStopMetadata={onStopMetadata}
          />
        </div>
      )}
    </div>
  );
};

export default ShowSummaryData;
